"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallAnimals = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const DecreaseAnyProduction_1 = require("../../deferredActions/DecreaseAnyProduction");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
class SmallAnimals extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SMALL_ANIMALS,
            tags: [Tags_1.Tags.ANIMAL],
            cost: 6,
            resourceType: ResourceType_1.ResourceType.ANIMAL,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oxygen(6)),
            metadata: {
                cardNumber: '054',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Add 1 Animal to this card.', (eb) => {
                        eb.empty().startAction.animals(1);
                    }).br;
                    b.production((pb) => pb.minus().plants(1).any).br;
                    b.vpText('1 VP per 2 Animals on this card.');
                }),
                description: {
                    text: 'Requires 6% oxygen. Decrease any Plant production 1 step.',
                    align: 'left',
                },
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.animals(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    canPlay(player) {
        const game = player.game;
        const someoneHasPlantProduction = game.someoneHasResourceProduction(Resources_1.Resources.PLANTS, 1);
        const otherPlayersHavePlantProduction = game.someoneElseHasResourceProduction(player, Resources_1.Resources.PLANTS, 1);
        Card_1.Card.setProductionDecreaseWarningText(this, Resources_1.Resources.PLANTS, otherPlayersHavePlantProduction);
        return super.canPlay(player) && someoneHasPlantProduction;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
    play(player) {
        player.game.defer(new DecreaseAnyProduction_1.DecreaseAnyProduction(player, Resources_1.Resources.PLANTS, 1));
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        player.addResourceTo(this, { log: true });
        return undefined;
    }
}
exports.SmallAnimals = SmallAnimals;
//# sourceMappingURL=SmallAnimals.js.map